import api from "../../Interceptor";
import { getRoute } from "../routes";

export const fetchUnreadCounts = async (userId) => {
  try {
    const response = await api.get(
      getRoute("users", "admin", "message", false) + `/unread-count/${userId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch unread counts", error);
  }
};
export const fetchUserUnreadCounts = async (userId) => {
  try {
    const response = await api.get(
      getRoute("users", "user", "message", false) + `/unread-count/${userId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch unread counts", error);
  }
};
